import moment from 'moment';
import DepsService from 'services/dependencies';
import { JACKPOT_ID, PRICES_PAID_WTD_ID, PRICES_PAID_MTD_ID, PRICES_PAID_YTD_ID, BIG_WINNERS_ID } from 'dashboard/dashboard-helpers';

const CONTEXT = 'socialMedia';

const BIG_WINNERS = 'big-winners';
const BIG_WINNERS_HISTORY = 'big-winners-history';
const CUMULATIVE_WINNERS = 'cumulative-winners';
const JACKPOT_AND_DRAWS = 'jackpots-and-draws';

export const setDateFormatAccordingToLocale = (locale) => {
  if (locale === 'en_US' || locale === 'es_US') return 'MM/DD/YYYY';

  return 'DD/MM/YYYY';
};

export const queryAccordingToPosterTemplate = ({ type, gameNumber, gameType, retailerId, locale, ...data }) => {
  const DATE_FORMAT = setDateFormatAccordingToLocale(locale);
  const common = {
    gameType,
    gameNumber,
    retailerId,
    locale,
  };

  switch (type) {
    case BIG_WINNERS:
    case BIG_WINNERS_HISTORY: {
      const { drawDate, wonAmount } = data;
      const date = moment.utc(drawDate).format(DATE_FORMAT);
      const amount = DepsService.$filter('currency')(wonAmount, undefined, 0);

      return {
        date,
        amount,
        ...common,
      };
    }
    case CUMULATIVE_WINNERS: {
      const { amount: wonAmount, wonDate } = data;
      const amount = DepsService.$filter('currency')(wonAmount, undefined, 0);
      const date = moment.utc(wonDate).format(DATE_FORMAT);

      return {
        amount,
        date,
        ...common,
      };
    }
    case JACKPOT_AND_DRAWS: {
      const { drawDate, amount: wonAmount } = data;
      const date = moment.utc(drawDate).format(DATE_FORMAT);
      const amount = DepsService.$filter('currency')(wonAmount, undefined, 0);

      return {
        date,
        amount,
        ...common,
      };
    }
    default: {
      // eslint-disable-next-line no-console
      console.error("Can't generating query params accordint to poster type:", type);
      return {};
    }
  }
};

export const getCumulativeTemplateAccordingToPeriodType = (periodType) => {
  switch (periodType) {
    case 'WTD':
      return PRICES_PAID_WTD_ID;
    case 'MTD':
      return PRICES_PAID_MTD_ID;
    case 'YTD':
      return PRICES_PAID_YTD_ID;
    default: {
      // eslint-disable-next-line no-console
      console.error("Can't map Cumulative Winners template for the period type:", periodType);
      return 0;
    }
  }
};

export const getPosterTemplate = ({ type, ...params }) => {
  switch (type) {
    case BIG_WINNERS:
    case BIG_WINNERS_HISTORY: {
      return BIG_WINNERS_ID;
    }
    case CUMULATIVE_WINNERS: {
      const { periodType } = params;
      return getCumulativeTemplateAccordingToPeriodType(periodType);
    }
    case JACKPOT_AND_DRAWS: {
      return JACKPOT_ID;
    }
    default: {
      // eslint-disable-next-line no-console
      console.error("Can't map poster template for the type:", type);
      return null;
    }
  }
};

export const downloadPoster = (params) => {
  const { url } = DepsService.rest.poster.download;
  const templateId = getPosterTemplate(params);

  const queryParams = queryAccordingToPosterTemplate(params);
  const urlParams = { templateId };
  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};

export const fetchPosterUrl = ({ serviceType, ...params }) => {
  const { url } = DepsService.rest.poster.get;

  const templateId = getPosterTemplate(params);
  const data = queryAccordingToPosterTemplate(params);

  const queryParams = {
    ...data,
    serviceType,
  };
  const urlParams = { templateId };
  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/utils/resources/rw-social-media.api.js